<template>
  <button
    class="slider__dot"
    @click="slideMove()"
  >
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'GlobalCarouselDot',
  props: {
    slideNumber: {
      type: Number,
      required: true,
    },
  },
  methods: {
    slideMove() {
      this.$parent.slideDotTrigger(this.slideNumber)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/GlobalCarouselDot.vue